import React from "react";
import DOMPurify from "dompurify";

export interface RichTextProps {
  html?: string;
  className?: string;
  tag?: keyof JSX.IntrinsicElements;
}

const RichText: React.FC<RichTextProps> = ({ html, className, tag = "div" }) => {
  const Tag = tag as React.ElementType;
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "") }}
    />
  );
};

export default RichText;
